import React from "react";
import "./DisputeTermsAndConditions.css";

const DisputeTermsAndConditions = () => {
  return (
      <main className='main'>
        <section className='section'>
          <div className="dispute-terms-container container">
            <h1 className='section-title'>Dispute Terms &amp; Conditions</h1>

            <section>
              <h2 >Dispute Resolution</h2>
              <h3>Handling Disputes Between Players and Operators</h3>
              <p>
                This section provides a clear overview of the procedures and guidelines
                for managing disputes between players and Operators, ensuring that all
                interactions are handled fairly and professionally.
              </p>
            </section>

            <section>
              <h2>General Guidelines</h2>
              <ul>
                <li>
                  <strong>Initial Handling by Operators:</strong> Operators are responsible
                  for addressing any concerns or disputes raised by players in a courteous
                  and professional manner. Anjouan Gaming will only step in if the Operator
                  fails to adhere to established protocols. Players should reach out to
                  Anjouan Gaming only if the parties are unable to achieve a satisfactory
                  resolution.
                </li>
                <li>
                  <strong>Dispute Escalation:</strong> Players experiencing issues such as
                  payout delays, account blocks, or technical problems should first attempt
                  to resolve these directly with the Operator. If a satisfactory resolution
                  isn’t achieved, the player may then escalate the issue to Anjouan Gaming
                  for further review.
                </li>
                <li>
                  <strong>Invalid claims:</strong> We do not entertain claims for activities
                  not covered by the Anjouan License, this includes players from prohibited
                  territories and activities outside gaming such as marketplaces or the
                  like. Such activities are outside the coverage of the license and as such
                  claims will not be entertained.
                </li>
              </ul>
            </section>

            <section>
              <h2>Operator’s Responsibility in Handling Complaints</h2>
              <h3>Notification Requirements:</h3>
              <ul>
                <li>
                  <strong>Game Outcome Disputes:</strong> Operators must include in their
                  Terms of Service that players are required to submit a formal complaint
                  within fourteen (14) calendar days following the session date if they
                  disagree with the outcome of a game.
                </li>
                <li>
                  <strong>Account-Related Issues:</strong> For other concerns related to
                  the user account, such as payout discrepancies, suspensions, or bonus
                  calculations, the complaint must be filed within thirty (30) calendar
                  days of the session date.
                </li>
                <li>
                  <strong>Offering Mediation:</strong> Operators have the option to offer
                  mediation as a voluntary and non-binding method to resolve disputes before
                  escalating them further.
                </li>
                <li>
                  <strong>Reporting to Anjouan Gaming:</strong> If an Operator does not
                  manage a complaint according to the industry’s best practices, they must
                  report the incident to Anjouan Gaming, especially if the issue remains
                  unresolved after thirty (30) calendar days.
                </li>
              </ul>
            </section>

            <section>
              <h2>Resolution of Unresolved Disputes</h2>
              <h3>Mandatory Arbitration:</h3>
              <ul>
                <li>
                  <strong>Arbitration Clause:</strong> Operators must include a clause in
                  their Terms of Service that unresolved disputes will be referred to binding
                  arbitration. The arbitration must be conducted by a tribunal recognized
                  by national law within the EU or the UK and must be held in English.
                </li>
                <li>
                  <strong>Time Limit for Arbitration:</strong> Players must initiate
                  arbitration within 180 days of the session date. Failure to do so will
                  result in the forfeiture of any potential claims.
                </li>
              </ul>
              <h3>Restrictions on Settlements:</h3>
              <ul>
                <li>
                  <strong>High-Value Disputes:</strong> Operators are prohibited from settling
                  disputes that involve amounts exceeding EUR 25,000 without first obtaining
                  approval from Anjouan Gaming.
                </li>
                <li>
                  <strong>Mandatory Reporting:</strong> Operators must report any legal claims
                  brought against them by third parties to Anjouan Gaming within two (2)
                  business days.
                </li>
              </ul>
            </section>

            <section>
              <h2>Anjouan Gaming’s Complaint Handling Process (CHP)</h2>
              <p>
                Anjouan Gaming’s CHP consists of a four-step process designed to ensure fair
                and impartial handling of complaints:
              </p>

              <h3>Validation Process:</h3>
              <ul>
                <li>
                  <strong>Complaint Submission:</strong> Anjouan Gaming will assess whether
                  a submitted complaint qualifies for Alternative Dispute Resolution (ADR).
                  The complaint must include the player’s full name, a valid email address,
                  and a clear explanation of the issue.
                </li>
                <li>
                  <strong>Agreement to ADR:</strong> Both parties must agree to resolve the
                  dispute through ADR rather than through litigation once the complaint is
                  validated.
                </li>
              </ul>

              <h3>Complaint Management After Validation:</h3>
              <ul>
                <li>
                  <strong>Operator’s Responsibility:</strong> Upon validation, the Operator
                  has Thirty (30) calendar days to demonstrate that they are actively working
                  to resolve the dispute. Anjouan Gaming will monitor this process to ensure
                  compliance.
                </li>
              </ul>

              <h3>Requests for Additional Information:</h3>
              <ul>
                <li>
                  <strong>Supporting Documentation:</strong> Anjouan Gaming may request further
                  details or evidence from either party to proceed with the complaint. All
                  communications must include both parties, except when confidentiality is
                  necessary.
                </li>
              </ul>

              <h3>Final Determination and Appeal:</h3>
              <ul>
                <li>
                  <strong>Issuing a Ruling:</strong> After reviewing all relevant information,
                  Anjouan Gaming will make a final decision.
                </li>
              </ul>
            </section>

            <section>
              <h2>Operator’s Obligations in Complaint Handling</h2>
              <ul>
                <li>
                  <strong>Effective Communication:</strong> Operators are required to manage
                  all player complaints professionally and promptly, in line with the Standard
                  of Good Industry Practice. Complaints must be addressed within Thirty (30)
                  calendar days of submission.
                </li>
                <li>
                  <strong>Accessible Complaint Procedures:</strong> Operators must maintain
                  a clear, accessible procedure for handling complaints. This procedure should
                  be available via a link on the website and included in the Terms of Service.
                </li>
                <li>
                  All complaints must be submitted via the operators interactive site seal
                  validator page. Attempts to submit claims via any other method is invalid
                  and will not be considered.
                </li>
              </ul>
            </section>
          </div>
        </section>
      </main>
  );
};

export default DisputeTermsAndConditions;